import { render, staticRenderFns } from "./NftFilter.vue?vue&type=template&id=6585b480&"
import script from "./NftFilter.vue?vue&type=script&lang=js&"
export * from "./NftFilter.vue?vue&type=script&lang=js&"
import style0 from "./NftFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports